export const SEND_VERIFICATION_EMAIL = 'sendverificationemail';
